<template>
  <v-card>
    <v-card-title>
      <h2 class="card-title">{{ 'base.edit' | translate }}</h2>
    </v-card-title>

    <v-card-content>
      <div class="form">
        <div class="form-row">
          <div class="form-column">
            <div class="form-element">
              <v-input-r
                v-model="form.first_name"
                :label="$t('base.first_name')"
                :hint="errorMessage('first_name')"
                :focus="true"
                :invalid="!!errorMessage('first_name')"
                @input="clearFieldError('first_name')"
              />
            </div>
          </div>

          <div class="form-column">
            <div class="form-element">
              <v-input-r
                v-model="form.last_name"
                :label="$t('base.last_name')"
                :hint="errorMessage('last_name')"
                :invalid="!!errorMessage('last_name')"
                @input="clearFieldError('last_name')"
              />
            </div>
          </div>
        </div>

        <div class="form-row">
          <div class="form-column">
            <div class="form-element">
              <v-input-r
                v-model="form.email"
                :label="$t('base.email')"
                :hint="errorMessage('email')"
                :invalid="!!errorMessage('email')"
                @input="clearFieldError('email')"
              />
            </div>
          </div>

          <div class="form-column">
            <div class="form-element">
              <v-input-r
                v-model="form.phone"
                :label="$t('base.phone')"
                :hint="errorMessage('phone')"
                :invalid="!!errorMessage('phone')"
                @input="clearFieldError('phone')"
              />
            </div>
          </div>
        </div>

        <div class="form-row">
          <div class="form-column">
            <div class="form-element">
              <v-input-r
                v-model="form.company_name"
                :label="$t('base.company_name')"
                :hint="errorMessage('company_name')"
                :invalid="!!errorMessage('company_name')"
                @input="clearFieldError('company_name')"
              />
            </div>
          </div>

          <!-- <div class="form-column">
            <div class="form-element">
              <v-select-r
                v-model="form.profile.language"
                :options="languages"
                :label="$t('base.select_lang')"
                item-text="name"
                item-value="key"
                :hint="errorMessage('language')"
                :invalid="!!errorMessage('language')"
                @input="clearFieldError('language')"
              />
            </div>
          </div> -->
          <div class="form-column">
            <div class="form-element">
              <v-select-r 
                v-model="form.profile.group" 
                :options="countries" 
                :label="$t('activities.country')"
                :hint="errorMessage('group')" 
                :invalid="!!errorMessage('group')" 
                :loading="loadingCountries"
                item-text="name" 
                item-value="id" 
                @input="clearFieldError('group')" 
              />
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="form-column">
            <div class="form-element">
              <v-input-r
                v-model="form.profile.about"
                :label="$t('base.about_client')"
                :hint="errorMessage('about_client')"
                :invalid="!!errorMessage('about_client')"
                @input="clearFieldError('about_client')"
              />
            </div>
          </div>
        </div>

        <div class="form-row">


          <div class="form-column">
            <div class="form-element">
              <v-card-actions class="justify-end">
                <v-btn 
                  color="green darken-1" 
                  dark 
                  @click="onUpdate" 
                  :loading="loading"
                  :disabled="loading"
                >
                  {{ $t('base.save') }}
                </v-btn>
              </v-card-actions>
            </div>
          </div>
          <div class="form-column"></div>
        </div>
      </div>
    </v-card-content>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import formErrorsMixin from '@/mixins/form-errors.mixin.js'

export default {
  name: 'SettingsClientModal',
  mixins: [formErrorsMixin],

  props: {
    item: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      loadingCountries: false,
      loading: false,
      errors: {},
      form: {
        email: '',
        first_name: '',
        last_name: '',
        phone: '',
        user_type: '',
        company_name: '',
        profile: {
          language: null,
          group: null,
          about: null
        }
      },
      languages: [
        { id: 0, name: 'English', key: 'en' },
        { id: 1, name: 'Українська', key: 'uk' },
        { id: 2, name: 'Русский', key: 'ru' },
        { id: 3, name: 'Polish', key: 'pl' },
        { id: 4, name: 'Nederlands', key: 'nl' },
        { id: 5, name: 'Deutschland', key: 'de' },
        { id: 6, name: 'France', key: 'fr' },
        { id: 7, name: 'Italia', key: 'it' },
        { id: 8, name: 'România', key: 'ro' },
        { id: 9, name: 'USA', key: 'us' }
      ]
    }
  },

  computed: {
    ...mapGetters('dashboard', ['currentUser']),
    ...mapGetters('countriesGroups', ['countriesGroups']),

    countries () {
      if (!this.countriesGroups || !this.countriesGroups.length) {
        return []
      }
      return this.countriesGroups.map(country => ({
        id: country.id,
        name: country.name
      }))
    }
  },

  async mounted () {
    await this.initialize()
  },

  methods: {
    ...mapActions('dashboard', ['updateUser', 'updateClient']),
    ...mapActions('countriesGroups', ['loadCountriesGroups']),

    async initialize () {
      try {
        this.loadData()
        await this.loadCountries()
      } catch (error) {
        console.error('Помилка ініціалізації:', error)
        this.showError('Помилка завантаження даних')
      }
    },

    async loadCountries () {
      this.loadingCountries = true
      try {
        await this.loadCountriesGroups()
      } catch (error) {
        console.error('Помилка завантаження країн:', error)
        this.showError('Не вдалося завантажити список країн')
      } finally {
        this.loadingCountries = false
      }
    },

    loadData () {
      const user = this.currentUser
      const item = this.item

      this.form = {
        email: (user && user.email) || '',
        first_name: (user && user.first_name) || '',
        last_name: (user && user.last_name) || '',
        phone: (user && user.phone) || '',
        user_type: (user && user.user_type) || '',
        company_name: (item && item.display_name) || (item && item.company_name) || '',
        profile: {
          language: (user && user.profile && user.profile.language) || null,
          about: (user && user.profile && user.profile.about) || '',
          group: (user && user.profile && user.profile.group) || null
        }
      }
    },

    clearFieldError (fieldName) {
      if (this.errors && this.errors[fieldName]) {
        this.$set(this.errors, fieldName, null)
      }
    },

    validate () {
      this.errors = {}
      const requiredFields = [
        'first_name',
        'last_name',
        'email',
        'phone',
        'company_name'
      ]

      requiredFields.forEach(field => {
        if (!this.form[field] || !this.form[field].trim()) {
          this.errors[field] = ['3']
        }
      })

      if (!this.form.profile.group) {
        this.errors.group = ['3']
      }

      if (this.form.email && !this.isValidEmail(this.form.email)) {
        this.errors.email = ['4']
      }

      return Object.keys(this.errors).length === 0
    },

    isValidEmail (email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      return emailRegex.test(email)
    },

    async onUpdate () {
      if (!this.validate()) {
        this.showError('Будь ласка, заповніть всі обов\'язкові поля')
        return
      }

      this.loading = true

      try {
        const userPayload = {
          id: this.currentUser.id,
          email: this.form.email.trim(),
          first_name: this.form.first_name.trim(),
          last_name: this.form.last_name.trim(),
          phone: this.form.phone.trim(),
          user_type: this.form.user_type,
          profile: {
            about: this.form.profile.about,
            language: this.form.profile.language,
            group: this.form.profile.group
          }
        }

        const userErrors = await this.updateUser(userPayload)

        if (this.form.company_name && this.form.company_name.trim()) {
          const clientData = {
            display_name: this.form.company_name.trim()
          }
          await this.updateClient({
            id: this.item.id,
            data: clientData
          })
        }

        if (!userErrors) {
          this.showSuccess('Редагування успішно збережено!')
          this.$emit('update')
          this.$emit('close')
        } else {
          this.handleErrors(userErrors)
        }
      } catch (error) {
        console.error('Помилка при збереженні:', error)
        this.showError('Помилка при збереженні редагування')
      } finally {
        this.loading = false
      }
    },

    handleErrors (errors) {
      this.errors = errors

      if (errors.email) {
        this.showError('Некоректний email!')
      } else if (errors.phone) {
        this.showError('Некоректний номер телефону!')
      } else {
        this.showError('Сталася помилка при оновленні!')
      }
    },

    showSuccess (message) {
      if (this.$toasted) {
        this.$toasted.success(message)
      }
    },

    showError (message) {
      if (this.$toasted) {
        this.$toasted.error(message)
      }
    }
  },

  watch: {
    currentUser: {
      handler () {
        if (this.currentUser) {
          this.loadData()
        }
      },
      deep: true
    },

    item: {
      handler () {
        if (this.item) {
          this.loadData()
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.v-card__actions {
  padding: 0;
  width: 100%;
}

.v-card__actions .v-btn {
  width: 100%;
}

.v-card__content {
  margin-top: 2rem;
  border-top: 0.1rem solid #d7d7d7;
  padding: 2rem;
  padding-top: 4rem;
}

.form {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.form-row {
  display: flex;
  gap: 40px;
  width: 100%;
}

.form-column {
  flex: 1;
  min-width: 0;
}

.form-element {
  width: 100%;
}

@media (max-width: 768px) {
  .form-row {
    flex-direction: column;
    gap: 12px;
  }
}
</style>